import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	align-items: center;
	min-width: 0;
	padding-left: 8px;
	gap: 4px;
`;
